"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoadRequestValidator = void 0;
const ValidationUtils_1 = require("./ValidationUtils");
class LoadRequestValidator {
    /**
     * Validate the widgetLoad Request received by the client.
     * @param request
     */
    static isValid(request) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        const violations = [];
        if (!ValidationUtils_1.ValidationUtils.isSafe(request)) {
            violations.push('widget load request object found to be null');
            return violations;
        }
        // If usecase details are not present, no fields should be present to prevent mixed requests
        // Proper validation of usecaseDetails can be found below.
        if (!request.usecaseDetails) {
            // Only ClientParams can be present incase usecase details are not found
            if (Object.keys(request).length > 1 || (Object.keys(request).length === 1 && !request.clientParams)) {
                violations.push('usecaseDetails not present in the request, partial request match found');
            }
            else {
                return violations;
            }
        }
        if (ValidationUtils_1.ValidationUtils.isSafe(request.ingressDetails)) {
            LoadRequestValidator.handleViolation(!ValidationUtils_1.ValidationUtils.isValidLocale((_a = request.ingressDetails) === null || _a === void 0 ? void 0 : _a.locale), `locale in widget load request found to be empty/null/undefined/invalid as it does not complies
                 with following regex :   ${ValidationUtils_1.ValidationUtils.LOCALE_REGEX} `, violations);
            LoadRequestValidator.handleViolation(ValidationUtils_1.ValidationUtils.isBlankString((_b = request.ingressDetails) === null || _b === void 0 ? void 0 : _b.obfuscatedMarketplaceId), 'obfuscatedMarketplaceId found to be empty/null/undefined in widget load request', violations);
        }
        else {
            violations.push('ingressDetails object found to be null in widget load request');
        }
        if (ValidationUtils_1.ValidationUtils.isSafe(request.userDetails)) {
            LoadRequestValidator.handleViolation(!ValidationUtils_1.ValidationUtils.isSafe((_c = request.userDetails) === null || _c === void 0 ? void 0 : _c.type), 'type found to be empty/null/undefined in widget load request', violations);
            LoadRequestValidator.handleViolation(!ValidationUtils_1.ValidationUtils.isValidUserIdRecord((_d = request.userDetails) === null || _d === void 0 ? void 0 : _d.userIds), 'userIdentifier found to be empty/null/undefined in widget load request', violations);
            LoadRequestValidator.handleViolation(!ValidationUtils_1.ValidationUtils.isValidBoolean((_e = request.userDetails) === null || _e === void 0 ? void 0 : _e.isUserVerified), 'isUserVerified found to be empty/null/undefined in widget load request', violations);
        }
        else {
            violations.push('userDetails object found to be null in widget load request');
        }
        if (ValidationUtils_1.ValidationUtils.isSafe(request.usecaseDetails)) {
            LoadRequestValidator.handleViolation(ValidationUtils_1.ValidationUtils.isBlankString((_f = request.usecaseDetails) === null || _f === void 0 ? void 0 : _f.usecaseId), 'usecaseId found to be empty/null/undefined in widget load request', violations);
        }
        else {
            violations.push('usecaseDetails object found to be null in widget load request');
        }
        if (ValidationUtils_1.ValidationUtils.isSafe(request.clientDetails)) {
            LoadRequestValidator.handleViolation(ValidationUtils_1.ValidationUtils.isBlankString((_g = request.clientDetails) === null || _g === void 0 ? void 0 : _g.clientId), 'clientId found to be empty/null/undefined in widget load request', violations);
        }
        else {
            violations.push('clientDetails object found to be null in widget load request');
        }
        if (ValidationUtils_1.ValidationUtils.isSafe(request.widgetConfig)) {
            LoadRequestValidator.handleViolation(ValidationUtils_1.ValidationUtils.isBlankString((_h = request.widgetConfig) === null || _h === void 0 ? void 0 : _h.header), 'header found to be empty/null/undefined in widget load request', violations);
        }
        else {
            violations.push('widgetConfig object found to be null in widget load request');
        }
        return violations;
    }
    static handleViolation(condition, mssg, violationList) {
        if (condition) {
            violationList.push(mssg);
        }
    }
}
exports.LoadRequestValidator = LoadRequestValidator;
